<template>
	<div class="boxide clearfix" id="boxIde">
		<!--遮盖蒙版-->
		<div id="ide_mask"></div>
		<!--canvas显示区-->
		<div id="boxide_lefts">
			<div id="GameDiv">
				<canvas id="GameCanvas" width="320" height="480"></canvas>
				<div id="splash">
					<div class="progress-bar stripes">
						<span style="width: 0"></span>
					</div>
				</div>
			</div>
		</div>
		<!--展示注释图片 ../../../static/images/comment/comment_1.png-->
		<div class="boxide_right_notes" v-if='CommentImgList'>
			<img id="image" :src='imagePath'  alt="" @load='changeImg()' @error="changeImgError()">
		</div>
		<!--右边容器	-->
		<div id="boxide_right" :class="{heightGO:!CommentImgList}" class="boxide_right" v-show="chooseMode == '1'">
			<div id="boxIde-rightMask" v-show="ideMask" ></div>
			<div class="questionMark" ref="questionMark" :style="{background: 'url(' + allImageMap.questionMark + ')'}" @click="checkImg()"></div>
			<div class="questionMark openAudio" ref="audio01" :style="{background: 'url(' + allImageMap.audio02 + ')'}" @click='checkAudioOpen()' v-show="!audioShow"></div>
			<div class="questionMark openAudio" ref="audio02" :style="{background: 'url(' + allImageMap.audio01 + ')'}" @click='checkAudioClose()' v-show="audioShow"></div>
			<div class='audio' v-show="audioOpenShow" :style="{backgroundImage: 'url('+createURL+'/static/images/audio/' + lang + '/sign03.png)',backgroundSize:'contain'}"></div>
			<!--IDE容器-->
			<div id="code-area" class="boxide_left"></div>
			<div style="width:100%;height:100%;position: absolute;z-index: 111110;" v-show="codeShow"></div>

		</div>
		<!--右边容器下方-->
		<div id="boxide_rightBottom" v-show="chooseMode == '1'">
			<p class="shrinkBars" @click="shrinkBars">
				<!--
					<i
					class="shrink_iconOp"
					:style="{background: 'url(' + allImageMap['41_03'] + ') no-repeat'}"
					v-show="shrinkBar"
				></i>
				<i
					class="shrink_iconCl"
					:style="{background: 'url(' + allImageMap['41_05'] + ') no-repeat'}"
					v-show="!shrinkBar"
				></i>
					-->
			</p>
			<!-- 按钮区域 左边背景 -->
			<div
				class="regionLeft"
				:style="{background: 'url(' + allImageMap['gameMain-di_0113'] + ') no-repeat'}"
			></div>
			<!-- 按钮区域 中心背景 -->
			<div
				id="regionCenter"
				:style="{background: 'url(' + allImageMap['aceBottom'] + ')'}"
				class="regionCenter"
			>
				<ul id="regionCenterUL" class="regionCenterUL">
					<li
						class="animated rubberBand"
						v-for="(item,index) in funVisibleArr"
						@click="clickActionImageButton(item,index)"
						@mouseover='seeStyle(item,index)' @mouseleave="leaveStyle(item,index)"
						:title="item.tips"
						ref="regionCenterLi"
						:key="index"
					>
						<img ref="liImg" class="regionImges" :src="item.img" alt ondragstart="return false;">
						<p :dir="dirs">{{item.describe}}</p>
					</li>
				</ul>
				<p
					class="actionSelectLeft"
					:style="{background: 'url(' + allImageMap['action_select_left'] + ') no-repeat'}"
					@click="actionSelectLeft"
					v-show="funIndex > 0"
				></p>
				<p
					class="actionSelectRight"
					:style="{background: 'url(' + allImageMap['action_select_left'] + ') no-repeat'}"
					@click="actionSelectRight"
					v-show="(funIndex + funShowCount < funArr.length) && (funShowCount > 0)"
				></p>
			</div>
			<!-- 按钮区域 右边背景 -->
			<div
				class="regionRight"
				:style="{background: 'url(' + allImageMap['gameMain-di_018'] + ') no-repeat', 'background-color': '#141414'}"
			>
				<div
					style="
						position: absolute;
						width: 15px;
						height: calc(187px);
						top: 0px;
						left: calc(45px - 5px);
					"
					@mouseover="btnRun_Hover(false), resetButton_Hover(false)"
				></div>
				<div
					style="
						position: absolute;
						width: 210px;
						height: 15px;
						top: 0px;
						left: calc(45px - 5px);
					"
					@mouseover="btnRun_Hover(false), resetButton_Hover(false)"
				></div>
				<!-- 重置按钮 -->
				<div class="mobile-btn-python">
					<div
						class="resetButton_hover"
						:style="{background: 'url(' + allImageMap['resetButtonPressed'] + ') no-repeat'}"
						@mouseleave="resetButton_Hover(false)"
						@click="clickResetCode_hover"
						v-show="mouseOverResetButton"
					></div>
					<div
						class="resetButton"
						:style="{background: 'url(' + allImageMap['resetButtonActive'] + ') no-repeat'}"
						id="resetCode"
						@mouseover="resetButton_Hover(true)"
						@click="clickResetCode"
						v-show="!mouseOverResetButton"
					></div>
					<!-- 停止按钮 -->
					<div
						class="stopButton_hover"
						:style="{background: 'url(' + allImageMap['stop02'] + ') no-repeat'}"
						@mouseleave="btnStop_Hover(false)"
						@click="clickStopCode_hover"
						v-show="mouseOverStopButton"
					></div>
					<div
						class="stopButton"
						:style="{background: 'url(' + allImageMap['stop01'] + ') no-repeat'}"
						id="stopCode"
						@mouseover="btnStop_Hover(true)"
						@click="clickStopCode"
						v-show="!mouseOverStopButton"
					></div>
					<!-- 运行按钮 -->
				</div>
				<div
					class="btnRun_hover"
					:style="{background: 'url(' + allImageMap['runButtonPressed'] + ') no-repeat'}"
					@mouseleave="btnRun_Hover(false)"
					@click="clickRunCode_hover"
					v-show="mouseOverRunButton"
				></div>
				<div
					class="btnRun"
					:style="{background: 'url(' + allImageMap['runButtonActive'] + ') no-repeat'}"
					id="runCode"
					@mouseover="btnRun_Hover(true)"
					@click="clickRunCode"
					v-show="!mouseOverRunButton"
				></div>
			</div>
		</div>
		<blockly v-if="chooseMode == '0'"></blockly>
	</div>
</template>

<script>
import store from "../../store";
import { mapGetters } from "vuex";
import blockly from "./blockly.vue";
import AdventureManager from "../../manager/AdventureManager";
import OperateDom from "../../manager/OperateDom";
import Cookies from 'js-cookie'

export default {
	data() {
		return {
			timerId: null,
			shrinkBar: true,
			mouseOverResetButton: false,
			mouseOverRunButton: false,
			mouseOverStopButton:false,
			createURL:process.env.GAME_CREATE_URL,
			notesImg:'',
			audioFlag:false,
			audioOpenShow:true,
			ideWidth: 640,
			// lan:''
		};
	},
	components: {
		blockly
	},
	mounted() {
		// 判断用户使用设备
		let os = function() {
			let ua = navigator.userAgent,
				isWindowsPhone = /(?:Windows Phone)/.test(ua),
				isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
				isAndroid = /(?:Android)/.test(ua),
				isFireFox = /(?:Firefox)/.test(ua),
				isChrome = /(?:Chrome|CriOS)/.test(ua),
				isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
				isPhone = /(?:iPhone)/.test(ua) && !isTablet,
				isPc = !isPhone && !isAndroid && !isSymbian;
			return {
				isTablet: isTablet,
				isPhone: isPhone,
				isAndroid: isAndroid,
				isPc: isPc
			};
		}();
		const lockScreen = (orientation) => {
			let de = document.documentElement;
				if (de.requestFullscreen) { de.requestFullscreen(); }
				else if (de.mozRequestFullScreen) { de.mozRequestFullScreen(); }
				else if (de.webkitRequestFullscreen) { de.webkitRequestFullscreen(); }
				else if (de.msRequestFullscreen) { de.msRequestFullscreen(); }

				screen.orientation.lock(orientation);
		}
		const unlockScreen = () => {
			screen.orientation.unlock();
			if (document.exitFullscreen) { document.exitFullscreen(); }
			else if (document.webkitExitFullscreen) { document.webkitExitFullscreen(); }
			else if (document.mozCancelFullScreen) { document.mozCancelFullScreen(); }
			else if (document.msExitFullscreen) { document.msExitFullscreen(); }
		}

		const changeToDeviceSize = () => {
			if (os.isAndroid || os.isPhone || os.isTablet) {
				// $("#boxide_lefts").css("width","500px")
				// $('.boxide .boxide_right').css({"width":'calc(100% - 500px)',"left":'500px'});
				// $('#boxide_rightBottom').css({"width":'calc(100% - 494px)',"left":'493px'});

				// kb
				var ideWidth = window.innerWidth / 3;

				$("#boxide_lefts").css("width", ideWidth + "px")
				$("#GameDiv").css("width", ideWidth + "px")
				$("#Cocos2dGameContainer").css("width", ideWidth + "px")
				$("#GameCanvas").css("width", ideWidth + "px")

				$('.boxide .boxide_right').css({"width":'calc(100% - ' + ideWidth + 'px)',"left":ideWidth + 'px'});
				$('#boxide_rightBottom').css({"width":'calc(100% - ' + (ideWidth - 6) + 'px)',"left":(ideWidth - 7) + 'px'});

				// lockScreen('landscape');
				this.ideWidth = ideWidth
				// kb
			}
		}

		changeToDeviceSize()

		const showTurnDevice = () => {
			if (window.matchMedia("(orientation: portrait)").matches) {
				$('body').append('<div id="turn-device"><p>Please rotate your device!</p></div>');
			}

			if (window.matchMedia("(orientation: landscape)").matches) {
				$('#turn-device').remove()
			}
		}

		showTurnDevice()

		$(window).on("orientationchange", function(event) {
			console.log( "This device is in " + event.orientation + " mode!" );
			showTurnDevice();
			window.location.reload();
		});

		const onDeviceResize = () => {
			if ((os.isAndroid || os.isPhone || os.isTablet) && this.chooseMode == '1') {
				if (window.innerHeight < 300) {
					$('.boxide').css({top: '0'});
					$('.boxide .heightGO').css({height: '100%'});
					$('.headBox, #boxide_rightBottom').hide();
				} else {
					$('.boxide').css({top: '45px'});
					$('.headBox, #boxide_rightBottom').show();
					$('.boxide .heightGO').css({height: 'calc(100% - 60px)'});
				}
			}
		}

		$(window).on('resize', function() {
			onDeviceResize()
		});

		this.lan = AdventureManager.getQueryString("zhOren");
		this.$nextTick(function() {
			window.addEventListener("resize", this.ideResize);
			window.addEventListener("click", () => {
				this.btnRun_Hover(false);
				this.resetButton_Hover(false);
			});
		});

		$(".regionImges").on("mousedown", function(e) {
			e.preventDefault();
		});

		window._ide_print_interval = 0.05;
	},
	methods: {
		 // 获取img图片真实宽高
		getImageWidth(url,callback){
			var img = new Image();
			img.src = url;
			// 如果图片被缓存，则直接返回缓存数据
			if(img.complete){
				callback(img.width, img.height);
			}else{
				img.onload = function(){
					callback(img.width, img.height);
				}
			}
		},
		changeImg(){
			let imgSrc = $("#image").attr("src");
			this.getImageWidth(imgSrc,(w,h)=>{
				let H = h + 'px';
				$('.boxide .boxide_right').css({"top":'175px'})
			});
		},
		checkImg(){
			OperateDom.getStyle(this.$refs.questionMark,store.state.allImageMap.questionMark01)
			setTimeout(()=>{
				store.state.imgList = [];
				if(window.bridge.getHelpImageData() == undefined || !window.bridge.getHelpImageData()) return;
				let arr = window.bridge.getHelpImageData(),arr1 = [];
				for(var i in arr) arr1.push(arr[i].image);
				let imgageUrl = this.createURL + "/static/images/operate/" + store.state.lang + "/";
				for(var j in arr1) store.state.imgList.push(imgageUrl+arr1[j])
				store.state.imgShow = true;
			},500)
		},
		changeImgError(){
		},
		// 开关背景音乐
		checkAudioOpen(){
			store.state.audioShow = true;
			window.bridge.toggleMusic(1);
		},
		checkAudioClose(){
			store.state.audioShow = false;
			window.bridge.toggleMusic(0);
		},
		update(dt) {
			this.mouseOverResetButton = this._overReset;
			this.mouseOverStopButton = this._OverStop
			this.mouseOverRunButton = this._overRun && !this._overReset && !this._OverStop;
		},
		// 设置重置按钮的hover
		resetButton_Hover(isEnter) {
			this._overReset = isEnter;
		},
		// 设置运行按钮的hover
		btnRun_Hover(isEnter) {
			this._overRun = isEnter;
		},
		// 设置停止按钮的hover
		btnStop_Hover(isEnter) {
			this._OverStop = isEnter;
		},
		//收缩抽屉
		shrinkBars() {
			if (this.shrinkBar) {
				// 抽屉 收缩
				$("#boxide_right").animate({ height: "100%" });
				$("#boxide_rightBottom").animate({ height: "0px" });
				$(".shrinkBars").animate({ top: "-16px" });
				$('.ace_scroller').css('zIndex','2')
				this.shrinkBar = false;
			} else {
				// 抽屉 打开
				let boxHeight = $("#boxIde").innerHeight();
				$("#boxide_right").animate(
					{ height: boxHeight - 196 * 0.8 + "px" },
					function() {
						$(this).css({ height: "calc(100% - 196px * .8)" });
					}
				);
				$("#boxide_rightBottom").animate({ height: "196px" });
				$(".shrinkBars").animate({ top: "36px" });
				$('.ace_scroller').css('zIndex','233333')
				this.shrinkBar = true;
			}
		},
		clickResetCode_hover() {
			store.state.skipStyleShow = false
			$("#resetCode").click();
		},
		//代码重置
		clickResetCode() {
			store.state.toBack = true;
			store.state.skipStyleShow = false
			AdventureManager.sendToGame("showResetCodeDialog");
		},
		clickStopCode(){
			store.state.ideMask = false;
			store.state.codeShow = false;
			AdventureManager.sendToGame("stopRunAction");
		},
		clickStopCode_hover(){
			store.state.codeShow = false;
			$("#stopCode").click();
		},
		seeStyle(item,index){
			OperateDom.setTransition(this.$refs.liImg,index,'1','scale(1.1)')
		},
		leaveStyle(item,index){
			OperateDom.setTransition(this.$refs.liImg,index,'.9','scale(1)')
		},
		//点击方法按钮,写入IDE代码
		clickActionImageButton(item,index) {
			this.$refs.regionCenterLi[index].classList.add('jello')
			// 如果代码正在运行, 则不处理
			if (window._code_is_running) {
				return;
			}
			if (this.timerId != null) {
				return;
			}
			let codeList = item.code.split("");
			let count = 0;
			this.timerId = setInterval(() => {
				if (codeList.length == count) {
					clearInterval(this.timerId);
					this.timerId = null;
					// 如果时需要聚焦到具体位置
					if (item.focus) {
						let selectEnd = editor.getSelectionRange().end;
						let row = Math.max(0, selectEnd.row - 1);
						let value = editor.getValue();
						let lines = value.split("\n");
						let line = lines[row];
						let lineLength = line.length;
						let posInLine = Math.max(0, lineLength - 1);
						editor.selection.setRange({
							start: { row: row, column: posInLine },
							end: { row: row, column: posInLine }
						});
					}
					return;
				}
				window.editor.insert(codeList[count]);
				count++;
				// 代码区获取焦点
				window.editor.focus();
				this.$refs.regionCenterLi[index].classList.remove('jello')
			}, window._ide_print_interval * 1000);
		},
		//窗口改变，自适应
		ideResize() {
			AdventureManager.toFront_adaptGameFrameSize(null, this.ideWidth);
			let percent = localStorage.getItem("percent");
			let leftPercent = "61.8%";
			if (percent != null) {
				let per = Number(percent);
				leftPercent = per * 100 + "%";
			}
			if (localStorage.getItem("status") === "default") {
				$("#lineSide").css({
					left: "calc(" + leftPercent + " - 6px)"
				});
			}
		},
		clickRunCode_hover() {
			if(store.state.lang == 'zh') store.state.qrCodeShow = true
			else store.state.qrCodeShow = false;
			$("#runCode").click();
			store.state.codeShow = window._code_is_running
		},
		//点击运行按钮
		clickRunCode() {
			this.audioOpenShow = false
			if (!window._inGame) {
				return;
			}
			$("#CanvasFrame").blur();
			this.$store.state.ideMask = true;
		},
		// 向左选动作
		actionSelectLeft() {
			if (store.state.funIndex == 0) {
				return;
			}
			store.state.funIndex--;
			AdventureManager.toFront_adaptGameFrameSize(null, this.ideWidth);
		},
		// 向右选动作
		actionSelectRight() {
			if (
				store.state.funIndex + store.state.funShowCount >=
				store.state.funArr.length
			) {
				return;
			}
			store.state.funIndex++;
			AdventureManager.toFront_adaptGameFrameSize(null, this.ideWidth);
		},
		forbidBackSpace(e) {
			console.log(e)
			// var ev = e || window.event;
			// var obj = ev.target || ev.srcElement; //获取事件源
			// console.log('dssd',ev.keyCode==8)
			//	e.stopPropagation();		// 阻止事件冒泡传递
			//	 e.preventDefault();		// 阻止浏览器默认事件的发生
			//	 return;
			var ev = e || window.event; //获取event对象
			var obj = ev.target || ev.srcElement; //获取事件源
			var t = obj.type || obj.getAttribute('type'); //获取事件源类型
			console.log('dssd',obj)

			//获取作为判断条件的事件类型
			var vReadOnly = obj.readOnly;
			var vDisabled = obj.disabled;
			//处理undefined值情况
			vReadOnly = (vReadOnly == undefined) ? false : vReadOnly;
			vDisabled = (vDisabled == undefined) ? true : vDisabled;
			//当敲Backspace键时，事件源类型为密码或单行、多行文本的，
			//并且readOnly属性为true或disabled属性为true的，则退格键失效
			// var flag1 = ev.keyCode == 8 && (t == "password" || t == "text" || t == "textarea")
			// //当敲Backspace键时，事件源类型非密码或单行、多行文本的，则退格键失效
			// var flag2 = ev.keyCode == 8 && !(t == "password" && t == "text" && t == "textarea");

			//判断
			return false;
	}
	},
	computed: {
		...mapGetters([
			"classIn",
			"courseware",
			"classTelescopic",
			"isLearning",
			"funArr",
			"funVisibleArr",
			"funShowCount",
			"funIndex",
			"ideMask",
			"allArr",
			"allImageMap",
			'CommentImgList',
			"imagePath",
			"audioShow",
			"lang",
			"skipStyleShow",
			"selectedPoint",
			"qrCodeShow",
			"codeShow",
			"blocklyShow",
			"chooseMode"
		]),
		dirs(){
			if(this.lan == 'ar' || this.lan == 'he'){
				return 'rtl'
			}else{
				return 'ltr'
			}
		},
	},
};
</script>

<style src="../../css/ide-box.css?v=1.1"></style>



// WEBPACK FOOTER //
// src/components/onlineClass/idebox.vue